import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import translate from "src/lib/translate";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import FaqComponent from "../../FaqComponent/FaqComponent";
import { useSearchParams } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const FaqDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();
  const [query] = useSearchParams();
  const context = query.get("context") ?? "default";

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  return (
    <InDialog
      popup
      title={translate("gettingStarted")}
      onClose={onClose}
      returnUrl={returnUrl}
    >
      <Container>
        <FaqComponent context={context} />
      </Container>
    </InDialog>
  );
};

export default FaqDialog;
